var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLocation24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 5.33337C21.68 5.33337 13.3334 13.68 13.3334 24C13.3334 38 32 58.6667 32 58.6667C32 58.6667 50.6667 38 50.6667 24C50.6667 13.68 42.32 5.33337 32 5.33337ZM18.6667 24C18.6667 16.64 24.64 10.6667 32 10.6667C39.36 10.6667 45.3334 16.64 45.3334 24C45.3334 31.68 37.6534 43.1734 32 50.3467C26.4534 43.2267 18.6667 31.6 18.6667 24Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 30.6667C35.6819 30.6667 38.6667 27.6819 38.6667 24C38.6667 20.3181 35.6819 17.3334 32 17.3334C28.3181 17.3334 25.3334 20.3181 25.3334 24C25.3334 27.6819 28.3181 30.6667 32 30.6667Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 18.8007,
    y1: 50.8562,
    x2: 54.2352,
    y2: 26.0521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0033AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0033AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 27.286,
    y1: 28.7141,
    x2: 36.7141,
    y2: 19.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0033AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0033AD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocation24Px);
export default __webpack_public_path__ + "static/media/ic_location_24px.0d1826c4a64cf5458d62a3f6e2e70f5a.svg";
export { ForwardRef as ReactComponent };